import {priceFormat} from './currency'; 
import { getTotalOrder } from './price';


const getIntent = (order,strings,store)=>{
    //console.debug('getIntent', order);
    let title =`${store.name}`;  
    let t=`%0a`
  
    if(order.version > 0){
      if(order.link){
        t+=`${encodeURIComponent(strings.ticket_title)}${order.id}, ${encodeURIComponent(title)}%0a`;
        t+=`${encodeURIComponent(order.link)}%0a`
      }
      //console.debug('store.textTicket',store.textTicket);


      if(store.textTicket==false){
        let message = "https://wa.me/phone?text=body"; 
        message = message.replace("body",t);
        //console.debug('message', message);
        return  message; 
      }
    }

    //console.debug('add intent body');

    if(order.type==="delivery" && order.deliveryPrice.status==='ok'){
      const address = order.fullAddress.address ? order.fullAddress.address:undefined;
      const details = order.fullAddress.details ? order.fullAddress.details:undefined;
      t+=`${"-".padEnd(50,'-')}%0a`
      t+=`${strings.delivery_address.toUpperCase()}:%0a`
      if(address){
        t+=`${encodeURIComponent(address)}%0a`
      } 
      if(details){
        t+=`${encodeURIComponent(details)}%0a`
      }

      if(order.fullAddress.geopoint && order.version < 1){
        const lat = order.fullAddress.geopoint.latitude; 
        const lng = order.fullAddress.geopoint.longitude; 
        const placeId = order.fullAddress.placeId ?
        `&query_place_id=${order.fullAddress.placeId}`:"";  
        const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}${placeId}`; 
        t+=encodeURIComponent(url); 
        t+=`%0a`
      }

    }else if(order.type==="takeaway"){
      t+=`${strings.order_takeaway}%0a`;
    }else if(order.type==="delivery"){
      t+=`${strings.delivery_price_no_include}%0a`; 
    }

    if(order.version < 1){
      t+=`${"-".padEnd(50,'-')}%0a`
      t+=`${strings.title_order.toUpperCase()} ID-${store.id}: %0a${encodeURIComponent(title)} %0a-`
    }

    if(order.payMethod){
      t+=`${"-".padEnd(50,'-')}%0a`
      const payment = order.payMethod.id
      t+=`${strings.title_payment_options.toUpperCase()}:  ${payment}%0a`;    
    }
    
    t+=`${"-".padEnd(50,'-')}%0a`
    t+=`${strings.title_summary.toUpperCase()}:%0a%0a`; 

    order.list.forEach(element => {
      const name = encodeURIComponent(element.name);  
      const price = toCurrency(store.currency,element.price,true)
      t+=`${name.padEnd(30,' .')}  x${element.count}   ${price}%0a`
    }
    ); 

    if(order.type==="delivery" && order.deliveryPrice.status==='ok'){
      if(order.deliveryPrice.normalPrice){
        const normal = getLabelNormalDelivery(order.deliveryPrice,strings);
        let normalPrice = order.deliveryPrice.normalPrice; 
        normalPrice = toCurrency(store.currency,normalPrice,true)
        t+=`%0a`
        t+=`${normal.padEnd(32,' .')} ${normalPrice}`
        t+=`%0a`
      }

      if(order.deliveryPrice.extraPrice>0){
        const extra = getLabelExtraDelivery(order.deliveryPrice,strings);      
        let extraPrice = order.deliveryPrice.extraPrice
        extraPrice = toCurrency(store.currency,extraPrice,true); 
        t+=`${extra.padEnd(28,' .')} ${extraPrice}`
        t+=`%0a`
      }
    }
    
    const value =getTotalOrder(order, order.deliveryPrice)
    let  total = toCurrency(store.currency,value);  
    total = encodeURIComponent(total);

    t+=`%0a`
    t+=`                 --------------------------%0a`
    t+=`                    ${strings.total}: ${total} %0a`
    t+=`                 --------------------------%0a`
    t+=`%0a`

    t+=` ${strings.delivery_to.toUpperCase()}`;
    const message = "https://wa.me/phone?text=body"
    //console.debug('message', message);
    return message.replace("body",t);
  }


  const toCurrency = (currency,value,hideSymbol)=>{
    return (currency) ?
           priceFormat(currency.style,value,currency.showCurrency&& !hideSymbol):
           value
  }



  const getLabelNormalDelivery = (delivery,strings)=>{
    const distance = delivery.normalRadius.toFixed(1);
    const labelPrice = distance ? `${strings.delivery_fee} ${distance}Km`
    : strings.order_delivery;
    return labelPrice;
  }
  const getLabelExtraDelivery = (delivery,strings)=>{
    const extraPrice = delivery.extraPrice ? delivery.extraPrice.toFixed(2):undefined;  
    const labelExtraPrice =   extraPrice ? 
    `${strings.delivery_extra}  ${delivery.extraByKm}x${delivery.extraDistance.toFixed(1)}Km`: undefined; 
    return labelExtraPrice; 
  }


export {
     getIntent,
     getLabelExtraDelivery, 
     getLabelNormalDelivery,
}